import { client } from '@hotjar/api-base-client';
import type { ResponseWithStatus } from '@hotjar/api-base-client';
import type { ServiceProductsResponse } from './service-products/model';
import type { ServiceProductsResponseDto } from './service-products/dto';
import { mapServiceProductsDtoToModel } from './service-products/mapper';

export async function getServiceProducts(accountId: number): Promise<ServiceProductsResponse> {
  if (!accountId) {
    throw new Error('id is mandatory');
  }

  return client<ServiceProductsResponse, ResponseWithStatus<ServiceProductsResponseDto>>({
    url: `/api/v1/accounts/${accountId}/service_management/products`,
    mapResponseData: (data) => ({
      effectiveNow: mapServiceProductsDtoToModel(data.effective_now),
      renewWith: mapServiceProductsDtoToModel(data.renew_with),
    }),
  });
}
